import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const candidatePoolTabs = {
    mobile: {
        cvTab: {
            rowWrapper: {
                display: "flex",
                flexDirection: "row",
                margin: "10.86vw 0 9.9vw 0"
            },
            text: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw"
            },
            link: {
                marginLeft: "10.62vw",
                textDecoration: "none",
                color: Color.Blue,
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "3.86vw"
            },
            icon: {
                marginLeft: "0.52vw",
                stroke: Color.Blue,
                width: "2.88vw",
                height: "2.88vw"
            },
            button: {
                marginLeft: "auto",
                width: "32.36vw",
                height: "8.45vw",                
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                fontWeight: "500",
                border: "2px solid " + Color.Green,
                color: Color.LightBlack,
                backgroundColor: Color.White
            },
            holder: {
                position: "relative" as "relative",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.41vw",
                height: "122.46vw",
                marginBottom: "7.60vw",
                overflow: "hidden"
            },
            layer: {
                position: "absolute" as "absolute",
                bottom: "0",
                left: "0",
                top: "0",
                right: "0",
                background: "transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box"
            },
            name: {
                marginBottom: "7px",
                position: "absolute" as "absolute",
                left: "1.04vw",
                bottom: "1.04vw",
                fontSize: "4.34vw",
                color: Color.White
            },
            popup:{
                justifyContent: "center",
                container: {
                    width: "90.33vw",
                    height: "166.67vw",
                    borderRadius: "2.41vw",
                    padding: "2.41vw"
                },
                closeButton: {
                    width: "3.86vw",
                    height: "3.86vw",
                    top: "1.93vw",
                    right: "1.93vw"
                }
            },             
            documentViewer: {
                height: "100%"
            }
        },
        infoTab: {
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "10.86vw 0 9.9vw 0"
            },
            details: {
                box: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.SharpAsh,
                    marginBottom: "2.41vw",
                    padding: "2.65vw 4.83vw"
                },
                title: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw",
                    marginBottom: "1.5vw"
                },
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "300",
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    userSelect: "text"
                },
                sector: {
                    width: "fit-content",
                    height: "3.91vh",
                    paddingLeft: "4.83vw",
                    paddingRight: "4.83vw",
                    marginRight: "1.21vw",
                    marginBottom: "0.56vh",
                    textAlign: "center",
                    lineHeight: "3.91vh",
                    borderRadius: "6.04vw",
                    backgroundColor: Color.Blue,
                    color: Color.LightBlue,
                    fontSize: "3.62vw",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "inline-block",
                    flex: "0 0 auto",
                    WebkitTapHighlightColor: "transparent",
                    userSelect: "none"
                }
            }
        },
        jobApplicationsTab: {
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "10.86vw 0 9.9vw 0"
            },
            jobApplication: {
                padding: "5.79vw",
                marginTop: "5.79vw",
                borderRadius: "2.41vw",
                border: "3px solid " + Color.Gainsboro,
                recordInfo: {
                    display: "flex"
                },
                calendarIcon: {
                    height: "3.73vw",
                    width: "auto"
                },
                detailsWrapper: {
                    marginLeft: "3.79vw",
                    fontWeight: "bold",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh
                },
                jobTitle: {
                    marginTop: "3.62vw",
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                }
            },
            noCandidates: {
                wrapper: {
                    borderRadius: "2.77vw",
                    border: "1px solid " + Color.HarvestGold,
                    backgroundColor: Color.LightGold,
                    display: "flex",
                    alignItems: "center" as "center",
                    justifyContent: "center" as "center",
                    padding: "2.41vh",
                    color: Color.HarvestGold,
                    fontSize: "4.5vw",
                    fontFamily: Font.Poppins,
                    margin: "21.73vw auto 0 auto",
                    textAlign: "center"
                },
                icon: {
                    marginRight: "1.43vw",
                    width: "8.33vw",
                    height: "8.33vw",
                    marginLeft: "1vw"
                }
            }
        },
        profileTab: {
            title: {
                color: Color.LightBlack,
                fontWeight: "bold",
                fontSize: "6.03vw",
                margin: "10.86vw 0 9.9vw 0"
            },
            personalSummary: {
                marginBottom: "7.24vw",
                title: {
                    color: Color.LightBlack,
                    fontWeight: "bold",
                    fontSize: "4.83vw"
                },
                text: {
                    color: Color.MiddleBlack,
                    fontWeight: "300",
                    fontSize: "3.86vw",
                    marginTop: "7.24vw",
                    userSelect: "text"
                }
            },
            seeMore: {
                color: Color.Blue,
                fontWeight: "bold",
                marginLeft: "2vw",
                cursor: "pointer"
            },
            details: {
                box: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.SharpAsh,
                    marginBottom: "2.41vw",
                    padding: "2.65vw 4.83vw"
                },
                title: {
                    color: Color.DeepAsh,
                    fontWeight: "bold",
                    fontFamily: Font.Poppins,
                    fontSize: "4.34vw"
                },
                text: {
                    color: Color.DeepAsh,
                    fontWeight: "300",
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    wordBreak: 'break-word',
                    userSelect: "text"
                }
            }
        }
    },
    desktop: {
        cvTab: {
            rowWrapper: {
                width: "29.75vw",
                margin: "2.08vw 0"
            },
            text: {
                color: Color.DeepBlack,
                fontSize: "1.56vw"
            },
            link: {
                marginLeft: "12.6vw",
                fontSize: "0.83vw"
            },
            icon: {
                marginLeft: "0.52vw",
                width: "0.6vw",
                height: "0.6vw"
            },
            button: {
                width: "6.97vw",
                height: "1.82vw",                
                borderRadius: "0.52vw",
                fontSize: "0.93vw"
            },
            holder: {
                borderRadius: "0.52vw",
                height: "35.2vw",
                marginBottom: "2.64vw"
            },
            name: {
                marginBottom: "7px",
                fontSize: "1.04vw"
            },
            popup:{
                container: {                    
                    width: "30.99vw",
                    height: "43.85vw",                    
                    borderRadius: "0.52vw",
                    padding: "0.83vw"
                },
                closeButton: {                    
                    width: "0.94vw",
                    height: "0.94vw",
                    top: "0.21vw",
                    right: "0.21vw"
                }
            }
        },
        infoTab: {
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "2.08vw 0",
                width: "29.75vw"
            },
            details: {
                marginBottom: "3.5vw",
                box: {
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    padding: "0.57vw 1.04vw"
                },
                title: {
                    fontSize: "0.93vw",
                    marginBottom: "0.7vw"
                },
                text: {
                    fontSize: "0.83vw",
                    maxWidth: {
                        maxWidth: "27.50vw"
                    }
                },
                sector: {
                    marginRight: "0.52vw",
                    marginBottom: "0.52vw",
                    width: "fit-content",
                    height: "1.822vw",
                    paddingLeft: "1.04vw",
                    paddingRight: "1.04vw",
                    lineHeight: "1.822vw",
                    fontSize: "0.78vw"
                }
            }
        },
        jobApplicationsTab: {
            content: {
                paddingBottom: "1.5vw",
            },
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "2.08vw 0",
                width: "29.75vw"
            },
            jobApplication: {
                padding: "1.25vw",
                margin: "0 0 1.5vw",
                borderRadius: "0.52vw",
                calendarIcon: {
                    height: "0.8vw"
                },
                detailsWrapper: {
                    marginLeft: "0.81vw",
                    fontSize: "0.83vw"
                },
                jobTitle: {
                    maxWidth: "26.87vw",
                    marginTop: "0.41vw",
                    fontSize: "0.93vw"
                }
            },
            noCandidates: {
                wrapper: {
                    borderRadius: "0.52vw",
                    margin: "10vh auto 0 auto",
                    padding: "1.56vw 0 1.56vw 0",
                    fontSize: "1.137vw"
                },
                icon: {
                    marginRight: "1.02vw",
                    width: "1.58vw",
                    height: "1.58vw"
                }
            }
        },
        profileTab: {
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "2.08vw 0",
                width: "29.75vw"
            },
            personalSummary: {
                marginBottom: "1.56vw",
                title: {
                    fontSize: "1.04vw"
                },
                text: {
                    fontSize: "0.83vw",
                    marginTop: "1.56vw",
                    maxWidth: "29.75vw"
                }
            },
            seeMore: {
                marginLeft: "0.5vw"
            },
            details: {
                marginBottom: "3.5vw",
                box: {
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    padding: "0.57vw 1.04vw"
                },
                title: {
                    fontSize: "0.93vw"
                },
                text: {
                    width: "27vw",
                    fontSize: "0.83vw"
                }
            }
        }
    }
}